import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant25() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title: 'Инвестируйте в бизнес, а не в код.',
      dev: 'Разработка',
      support: 'Поддержка',
      sub: 'Мы создаем премиальные сайты с нулевыми стартовыми вложениями. Вы платите только за бесперебойную работу вашего ресурса.',
      cta: 'Оставить заявку'
    },
    ua: {
      title: 'Інвестуйте в бізнес, а не в код.',
      dev: 'Розробка',
      support: 'Підтримка',
      sub: 'Ми створюємо преміальні сайти з нульовими стартовими вкладеннями. Ви платите лише за безперебійну роботу вашого ресурсу.',
      cta: 'Залишити заявку'
    },
    en: {
      title: 'Invest in your business, not in code.',
      dev: 'Development',
      support: 'Support',
      sub: 'We build premium websites with zero upfront costs. You only pay for the seamless operation of your resource.',
      cta: 'Submit request'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-543">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-544">
          {/* Left Column - Modern SaaS Badge */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-545">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-8 text-4xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight text-gray-900" data-id="element-546">
              {content.title}
            </motion.h1>

            {/* Inline Offer Badge */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="flex items-center gap-6 p-2 pr-6 rounded-full bg-white border border-gray-200 shadow-md mb-8" data-id="element-547">
              <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-green-50 text-green-700 font-bold text-sm" data-id="element-548">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-549" />
                {content.dev} 0$
              </div>
              <div className="font-bold text-gray-800 text-sm" data-id="element-550">
                {content.support} {price}/мес
              </div>
            </motion.div>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-lg md:text-xl mb-10 text-gray-600 font-medium max-w-lg leading-relaxed" data-id="element-551">
              {content.sub}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} data-id="element-552">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-xl px-8 py-4 font-bold text-lg transition-all hover:scale-105" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-553">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-554" />
              </button>
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-555">
            <div className="relative w-full max-w-2xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-gray-100" data-id="element-556">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-557" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-558" />
    </>;
}